export enum SettingsViewMode {
  BIRDS_EYE_VIEW = 'birdsEyeView',
  POV_VIEW = 'POVView',
}

export enum SettingsMapType {
  SATELLITE = 'satellite',
  ABSTRACT = 'abstract',
}

export type Settings = {
  mapType: SettingsMapType;
  viewMode: SettingsViewMode;
  fovForBirdsEyeView: number;
  fovForPOVView: number;
};
